/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdActionSheetProps } from './type';

export const actionSheetDefaultProps: TdActionSheetProps = {
  align: 'center',
  count: 8,
  popupProps: {},
  showCancel: true,
  showOverlay: true,
  theme: 'list',
  defaultVisible: false,
};
